<template>
    <div >

        <div class="  ">
            <el-select v-if="data.type=='kan'" class="inputwidth" @change="changeType" size="mini"  style="width:130px;" v-model="i_type">
                <el-option v-for="(val,index) in typeList"  :label="val.text" :value="val.value"></el-option>
            </el-select>
            <el-input
                    style="width: 220px"
                    size="mini"
                    class="input m-b9"
                    placeholder="搜索人名"
                    v-model="search"
                    clearable>
            </el-input>

            <el-button class="mrl20" style="margin-left: 10px" icon="el-icon-search" circle  @click="searchFun" size="mini"></el-button>
        </div>

            <el-table stripe ref="table" :header-cell-style="{background:'#f5f7fa',color:'#000'}" size="mini"
            @selection-change="handleSelection" row-key="subId"
            :height="tableHeight" border  :data="tableData" style="width: initial;">
                <!--            <el-table-column type="selection" align="center"></el-table-column>-->
                <!--            <el-table-column align="center" label="日期" prop="forDate">-->
                <!--                <template class="flex"  slot-scope="scope">-->
                <!--                    <el-date-picker class="m-l14" size="mini" v-model="scope.row.date" type="month" placeholder="选择日" format="yyyy-MM" value-format="yyyy-MM"></el-date-picker>-->

                <!--                </template>-->
                <!--            </el-table-column>-->
                <el-table-column type="selection" width="55" :reserve-selection="true" :selectable="selectable"></el-table-column>
                <el-table-column align="center" label="姓名" prop="userName" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="部门" prop="departmentName" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="状态" prop="stateTxt"  show-overflow-tooltip>
                    <template class="flex"  slot-scope="scope">
                        <span :class="(scope.row.i_isconfirmed==-1||scope.row.i_isconfirmed==-2)?'red':(scope.row.i_isconfirmed==0)?'blue':'green'">{{scope.row.stateTxt}}</span>
                    </template>
                </el-table-column>
<!--                    <el-table-column align="center" label="类型" prop="overtimeType" width="140" show-overflow-tooltip>-->
<!--                        <template class="flex"  slot-scope="scope">-->
<!--                            <el-radio-group v-model="scope.row.overtimeType" size="mini"  v-if="canEdit" @input="scope.row.change='change'">-->
<!--                                <el-radio :label=2  >调休</el-radio>-->
<!--                                <el-radio  :label=1 >薪资</el-radio>-->
<!--                            </el-radio-group>-->
<!--                            <span v-else>{{scope.row.overtimeType==1?'薪资':'调休'}}</span>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                <el-table-column align="center" label="开始时间" prop="startTime" show-overflow-tooltip>
                    <template class="flex"  slot-scope="scope">
                        <el-date-picker style="width: initial;" :picker-options="pickerOptions" v-if="canEdit"  @change="startTimeChange($event,scope.row)" size="mini" v-model="scope.row.startTime" type="datetime" placeholder="选择开始时间" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"></el-date-picker>
                        <span v-else>{{scope.row.startTime}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="结束时间" prop="endTime" show-overflow-tooltip>
                    <template class="flex"  slot-scope="scope">
                        <el-date-picker style="width: initial;" v-if="canEdit"  @change="endTimeChange($event,scope.row)" size="mini" v-model="scope.row.endTime" type="datetime" placeholder="选择结束时间" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"></el-date-picker>
                        <span v-else>{{scope.row.endTime}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="时长" prop="overtimeHour"  width="90" show-overflow-tooltip>
                    <template class="flex"  slot-scope="scope">
                        <el-input-number style="width: initial;" v-if="canEdit"  @change="scope.row.change='change'"  :precision="1" v-model="scope.row.overtimeHour"  size="mini" :step="0.5" :min="0.5" :controls="false" :step-strictly="true"></el-input-number>
                        <span v-else>{{scope.row.overtimeHour}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="事由" prop="vc_reason"  show-overflow-tooltip>
                    <template class="flex"  slot-scope="scope">
                        <el-input style="width: initial;" v-if="canEdit"  v-model="scope.row.vc_reason"  size="mini" ></el-input>
                        <span v-else>{{scope.row.vc_reason}}</span>

                    </template>
                </el-table-column>
                <el-table-column align="center" label="是否补卡" prop="i_isbk" width="90" show-overflow-tooltip>
                    <template class="flex"  slot-scope="scope">

                        <span>{{scope.row.i_isbk==1?'是':'否'}}</span>
                    </template>
                </el-table-column>
                    <el-table-column align="center" label="异常原因" prop="vc_exception_note"  show-overflow-tooltip></el-table-column>

            </el-table>
            <el-pagination  style="margin-top: 10px;text-align: right"
                            background
                            @current-change="pageCurrentChange"
                            layout="total,prev, pager, next"
                            :current-page.sync="currentPage"
                            :total="total"
                            :page-size="pageSize">
            </el-pagination>
        <div  class="center">
            <el-button type="primary" @click="editSave" :disabled="multipleSelection.length==0" :class="baseerp+'btn'" size="small" >补卡</el-button>
<!--            <el-button type="primary" @click="edit" :disabled="flow||multipleSelection.length==0" :class="baseerp+'btn'" size="small">编辑</el-button>-->
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";

    import {mapActions} from "vuex";
    const getYm=()=>{
        let newD=new Date();
        let y=newD.getFullYear();
        let m=newD.getMonth()+1;
            m=m>9? m : '0'+m;
        return y+'-'+m
    };
    export default {
        name: "jiaBan",

        props:{
            data:{
                type:Object,
                required:true
            },
        },
        data(){
            return{
                baseerp:baseerp,
                search:'',
                searchname:'',
                searchPeople:[],
                disabled:false,
                tableHeight:0,//列表高度
                tableData:[],
                currentPage:1,
                pageSize:20,
                total:0,
                rmcurrentPage:1,
                rmpageSize:20,
                rmtotal:0,
                canEdit:false,
                canBkEdit:false,
                flow:false,
                back:'back',
                personid:null,
                department:null,
                delList:[],
                pickerOptions:{

                },
                multipleSelection:[],
                typeList:[
                    {text:'全部',value:0},
                    {text:'异常',value:1},
                    {text:'正常',value:2},
                ],
                i_type:0,
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
            data:{
                handler(n,o) {
                    if(this.data.type=='edit'){
                        this.i_type=1
                        // console.log(' this.i_type', this.i_type)
                    }
                },
                deep:true,
            },

        },
        activated(){
            this.onResize();
        },
        mounted(){
            // this.$refs.radio.$children.forEach(item=>{
            //     item.$refs.radio.removeAttribute('aria-hidden')
            // })
            if(this.data.type=='edit'){
                this.i_type=1
                // console.log(' this.i_type', this.i_type)
            }
            this.overtimeList()
            this.$nextTick(()=>{
                this.onResize();

            })
            let that=this
            this.pickerOptions={
                disabledDate(time){
                    let y=time.getFullYear();
                    let m=time.getMonth()+1;
                    m=m>9? m : '0'+m;
                    let ym=y+'-'+m;
                    if(ym==that.data.dt_formonth){
                        return false
                    }else{
                        return true
                    }
                }
            }
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-200
            },
            selectable(row){
                if(row.stateTxt=='校验异常'){
                    return true
                }else{
                    return false
                }
            },
            changeType(){
                this.currentPage=1
                this.overtimeList()
            },
            handleSelection(val){
                this.multipleSelection=val
                // console.log(this.multipleSelection)
            },
            edit(){
                this.canEdit=true
                this.canBkEdit=true
                this.currentPage=1
                this.overtimeList()

            },
            editSave(){
                // let list=JSON.parse(JSON.stringify(this.multipleSelection)) ;
                // list.map(item=>{
                //     item.i_handle_except=item.subId
                //     item.subId=0
                //     item.i_isbk=1
                //     item.change='change'
                // })
                // this.$emit('close','save',list)
                this.saveOvertime()

            },
            startTimeChange(e,row){
                row.change='change';
                if(row.endTime){
                    let end=new Date(row.endTime+':00'),start=new Date(row.startTime+':00'),
                        dif=end - start;
                    if(dif>24*60*60*1000||dif<=0){
                        this.$message.error('时间区间需大于0小于等于24')
                        row.startTime=''
                    }
                }
            },
            endTimeChange(e,row){
                row.change='change';
                if(row.startTime){
                    let end=new Date(row.endTime+':00'),start=new Date(row.startTime+':00'),
                        dif=end - start;
                    if(dif>24*60*60*1000||dif<=0){
                        this.$message.error('时间区间需大于0小于等于24')
                        row.endTime=''
                    }
                }
            },
            //名称搜索
            searchFun(val){
                this.currentPage=1
                this.overtimeList()
            },
            //名字选择
            chooseRmFun(val){
                this.personid=val.id
                this.personname=val.name;
                this.department=val.department;
                if(!this.canEdit)this.overtimeList()

            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.overtimeList();

            },
            rmpageCurrentChange(val){
                this.rmcurrentPage=val;
                //调用列表接口
                this.searchUser();

            },

            // async saveOvertime() {
            //     let list=JSON.parse(JSON.stringify(this.multipleSelection)) ;
            //     list.map(item=>{
            //         item.i_handle_except=item.subId
            //         item.subId=0
            //         item.i_isbk=1
            //     })
            //     let params = {
            //         dt_formonth:this.data.dt_formonth,
            //
            //         sub:list,
            //         i_id:this.data.i_id
            //     };
            //     // console.log(params,'params')
            //     // return
            //     this.flow=true
            //     this.canEdit=false
            //     this.canBkEdit=false
            //
            //     let res = await API.saveOvertimeSq(params);
            //     if (res.code == 1) {
            //         this.$message.success(res.message);
            //         this.back='save'
            //         this.cancel()
            //        // this.overtimeList()
            //     } else if (res.code == -2) {
            //         this.$router.push('/login');
            //         this.$message.error(res.message);
            //     } else {
            //         this.$message.error(res.message);
            //         this.flow=false
            //
            //     }
            // },

            async overtimeList(){
                this.delList=[]
                // if(this.listparamid){
                let param={
                    currentPage:this.currentPage,
                    pageSize: this.pageSize,
                    vc_search:this.search,
                    forMonth:this.data.dt_formonth,
                    i_type:this.i_type,

                };
                let res=await API.listOvertimeExcept(param);
                if(res.code==1){
                    this.tableData=res.data.list;
                    this.total=res.data.total;

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
                // }else{
                //     this.$message.warning('请选择产品')
                // }

            },
            cancel(){
                this.$emit('close',this.back)
            },
            async saveOvertime() {
                // let list=this.tableData.filter(l=>l.change=='change'),cansave=true;
                // for(let l of list){
                //     if (!l.startTime||!l.endTime){
                //         this.$message.error('请填写开始时间/结束时间');
                //         cansave=false
                //     };
                //     if(!l.overtimeHour){
                //         this.$message.error('请填写加班时长');
                //         cansave=false
                //     };
                // };
                // if(!cansave){
                //     return
                // }
                // if(this.delList.length==0&&list.length==0){
                //     this.$message.error('无更改数据');
                //     return
                //
                // }
                if(this.multipleSelection.length>0)this.month=this.multipleSelection[0].startTime.substring(0,7)
                this.multipleSelection.map(item=>{
                    item.i_handle_except=item.subId
                    item.subId=0
                    item.i_isbk=1
                    item.change='change'
                })
                let params = {
                    dt_formonth:this.month,
                    delSubs:this.delList,
                    sub:this.multipleSelection,
                    i_id:this.data.i_id,
                    i_isbk:1
                };
                // console.log(params,'params')
                // return
                this.flow=true
                this.canEdit=false
                this.canBkEdit=false

                let res = await API.saveOvertimeSq(params);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.back='save'
                    this.cancel()
                    // this.overtimeList()
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                    this.flow=false

                }
            },
            async flowSub(item){
                this.flow=true
                this.$message.success('正在提交，请稍候')
                let param={
                    i_id:this.data.i_id,
                    i_fileid:this.data.i_fileid,
                    i_newname:this.data.i_filenewname,
                };
                let res=await API.getOvertimeSqPdf(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.back='save'
                    this.cancel()
                    this.flow=false
                }else if (res.code == -2) {
                    this.flow=false

                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.flow=false
                    this.$message.error(res.message);
                }
            },
       }
    }
</script>

<style lang="scss" scoped>
    .red{
        color: red;
    }
    .green{
        color: green;
    }
    .blue{
        color: dodgerblue;
    }
.p14{
    padding: 14px;
}
    .m-l14{
        margin-left: 14px;
    }
    .m-b9{
        margin-bottom: 9px;
    }
    .datetxt{
        font-size: 14px;
        display: inline-block;
        width: 50px;
    }
    .flex{
        display: flex;
        align-items: center;
    }
    .jcsb{
        justify-content: space-between;
    }
    /deep/{
        .el-radio{
            margin-right: 7px !important;
        }
    }
    .center{
        text-align: center;
    }
    .ghwdiv{
        .active{
            background-color: var(--opacityghw);
        }
        i{
            color: var(--darkghw);
            padding-top: 3px;
            padding-right: 6px;
        }
    }
    .havaydiv{
        .active{
            background-color: var(--opacityhavay);
        }
        i{
            color: var(--darkhavay);
            padding-top: 3px;
            padding-right: 6px;
        }
    }
    .fkbox{
        padding: 5px 9px;
        cursor: pointer;
    }
    .p-5-9{
        padding: 5px 9px;

    }
    .flex{
        display: flex;

    }
    div{
        /*font-size: 12px;*/
        line-height: 1.5;
    }
</style>